import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import Select from '@mui/material/Select';
import moment from 'moment';
import React, { createRef, useEffect, useRef, useState } from 'react';
import Loader from 'src/components/common/Loader';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import staticData from '../../../../resources/static.json';
import '../SubjectTracking.scss';
import DJ2Form from './configurableformprovider';
// import { dataDummy } from './data';
import {
  useCreateVerificationMutation,
  useGetAllVerificationMutation,
  useLazyGetVisitLinkedCRFsQuery,
  useSourceDataReviewStatusMutation
} from 'src/services/SubjectTrackingDetails';
// import { useCRFForms } from './useCRFForms';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
// import { useTrailNotebookCRF } from '../PatientTrialNoteBook/useTrailNotebookCRF';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useGetQueriesQuery } from 'src/services/Queries';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import '../SubjectTracking.scss';
import AuditTrailContent from './AuditTrailLayout';
import ViewQuery from './ViewQuery';
import { ReactComponent as BookmarkIcon } from './bookmark_visits.svg';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { archLevel } from 'src/data/config';
import { useCRFForms } from '../../CRFForms/useCRFForms';
import { ContentLoader } from '@pihealth/common-ui-library';

const CRFHistoryModal: React.FunctionComponent<any> = ({
  handleCloseModel,
  formConfig,
  parent_id,
  isUpdate,
  selectedVisit,
  editRowData,
  setselectedVisit,
  bookMarkKey,
  bookMarkField,
  getPatientsDetailsData,
  subject_id,
  eventDataLoading
}: any) => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const user = useAppSelector(state => `${state.user.user?.firstName} ${state.user.user?.lastName}`);
  const dispatch = useAppDispatch();
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [dj2FormConfig, setDJ2FormConfig] = useState<any>(null);
  const [toVerifyItems, settoVerifyItems] = useState<number>(0);
  const [verifiedItems, setverifiedItems] = useState<number>(0);
  const [sourceDataReviewActive, setSourceDataReviewActive] = useState<boolean>(false);
  const [tempFormConfigdata, setTempFormConfigdata] = useState<any>([]);
  const [openQueryDialog, setOpenQueryDialog] = useState<boolean>(false);
  const [openRaiseQuery, setOpenRaiseQuery] = useState(false);
  const [queryObj, setQueryObj] = useState<any>({});
  const [allQueries, setAllQueries] = useState<any>([]);
  const [raisedQuerys, setRaisedQuerys] = useState([]);
  const [showQuerys, setShowQuerys] = useState<any>([]);
  const [openFieldAuditTrail, setOpenFieldAuditTrail] = useState(false);
  const [openAuditTrailCRF, setOpenAuditTrailCRF] = useState(false);
  const [openFieldAuditTrailCRF, setOpenFieldAuditTrailCRF] = useState(false);
  const { checkPermission } = usePermissionWrapper();
  const dispatchApp = useAppDispatch();
  const queryMenu = staticData.query_menu.filter(
    (ele: any) => checkPermission(ele.permission) && (ele.level === 'all' || ele.level === archLevel)
  );
  const [dataEntryNum, setdataEntryNum] = useState(null);
  const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
  const [showFields, setShowFields] = useState<any>({});
  const [isSectionQuery, setIsSectionQuery] = useState(false);
  const [sectionQuerys, setSectionQuerys] = useState<any[]>([]);
  const { getCheckboxValue, getRadioButtonValue } = useCRFForms();
  useEffect(() => {
    if (selectedVisit) {
      let lastEventData = null;
      if (selectedVisit.crf_data.length > 0) {
        lastEventData = selectedVisit.crf_data[0].result;
      }
      if (editRowData && isUpdate) {
        setdataEntryNum(editRowData.event_number);
      } else {
        setdataEntryNum(lastEventData ? lastEventData.event_number + 1 : 1);
      }
    }
  }, [isUpdate, editRowData]);

  const [
    getVisitLinkedCRFs,
    { data: getVisitLinkedCRFsData, isSuccess: getVisitLinkedCRFsIsSuccess, isLoading: getVisitLinkedCRFsIsLoading }
  ] = useLazyGetVisitLinkedCRFsQuery();
  const [
    createVerification,
    {
      data: createVerificationData,
      isError: createVerificationIsError,
      isSuccess: createVerificationIsSuccess,
      isLoading: createVerificationIsLoading,
      error: createVerificationError
    }
  ] = useCreateVerificationMutation();
  const [sourceDataReviewStatus] = useSourceDataReviewStatusMutation();
  const [
    getAllVerification,
    {
      data: getAllVerificationData,
      isError: getAllVerificationIsError,
      isSuccess: getAllVerificationIsSuccess,
      isLoading: getAllVerificationIsLoading,
      error: getAllVerificationError
    }
  ] = useGetAllVerificationMutation();

  const bindDefaultValuesToForm = (clonedObj: any) => {
    clonedObj.sections.map((section: any) => {
      section.rows.map((row: any) => {
        row.fields.map((field: any) => {
          field.isCustomForm = true;
          if (field.cmp == 'checkbox' && field?.default_value && field?.default_value.length > 0) {
            let values = {};
            field?.default_value.map((val: any) => {
              values = { ...values, [val]: true };
            });
            // field.default_value = values;
          } else if (
            field?.cmp == 'select' &&
            field?.default_value &&
            field?.data_dictionary_values &&
            field?.data_dictionary_values.length > 0
          ) {
            if (field?.multiple) {
              const values = [];
              for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                if (field?.default_value.includes(field?.data_dictionary_values[i].value)) {
                  values.push({
                    label: field?.data_dictionary_values[i].code_list_value,
                    value: field?.data_dictionary_values[i].value
                  });
                }
              }
              field.default_value = values;
            } else {
              let values = {};
              for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                if (field?.data_dictionary_values[i].value == field?.default_value) {
                  values = {
                    label: field?.data_dictionary_values[i].code_list_value,
                    value: field?.data_dictionary_values[i].value
                  };
                  break;
                }
              }
              field.default_value = values;
            }
          }
        });
      });
    });
    return clonedObj;
  };

  const getDefualtValuesAndRules = (formJsonMeta: any) => {
    let initialValues = {};
    let rules = {};
    if (formJsonMeta?.sections) {
      const formData = formJsonMeta.sections.flatMap((section: any) => section.rows.flatMap((row: any) => row.fields));
      const initValues = formData.reduce(
        (acc: any, cur: any) => ({ ...acc, [cur.key]: cur.default_value || null }),
        {}
      );
      initialValues = initValues;
      let mockRulesObj: any = {};
      formData.map((item: any) => {
        if (item?.required && item?.cmp != 'checkbox') {
          const makeObj = {
            required: {
              value: true,
              errorText: 'Required'
            }
          };
          mockRulesObj = { ...mockRulesObj, [item.key]: makeObj };
        }
      });
      rules = mockRulesObj;
    }
    return { initialValues, rules };
  };

  /**
   * ADD NEW LINK CRF Functionality Start
   */

  useEffect(() => {
    if (selectedVisit) {
      getVisitLinkedCRFs({
        visit_id: selectedVisit.study_visit.id,
        study_id: studyId,
        site_id: selectedSite,
        country: selectedCountry
      });
    }
  }, [isUpdate, selectedVisit]);

  const { data: crfAssociationData } = useGetCodeListDataQuery('CRFASSOCIATION');

  const [crfAssociation, setCrfAssociation] = useState([]);
  useEffect(() => {
    if (crfAssociationData) {
      const vals: any = [];
      crfAssociationData.map((ass: any) => {
        vals.push(ass.code_list_value);
      });
      setCrfAssociation(vals);
    }
  }, [crfAssociationData]);

  const [listOfcurrentSelectedLinkedCRFs, setlistOfcurrentSelectedLinkedCRFs] = useState<any>(null);
  const onDJ2Change = (data: any) => {
    const updatedData = listOfcurrentSelectedLinkedCRFs.map((obj: any) => {
      if (obj.event_number === data.formId) {
        return { ...obj, initialValues: data };
      } else {
        return obj;
      }
    });
    setlistOfcurrentSelectedLinkedCRFs(updatedData);
  };

  const handleChangeAssociation = async (event: any, event_number: any, crf_type: any) => {
    const modifiedData: any = [];
    let findlinkData: any = null;
    let currentLinkCRF = null;
    for (let i = 0; i < listOfcurrentSelectedLinkedCRFs.length; i++) {
      if (
        listOfcurrentSelectedLinkedCRFs[i].event_number == event_number &&
        crf_type === listOfcurrentSelectedLinkedCRFs[i].native_crf_type
      ) {
        if (event.target.name == 'associationTerm') {
          setcurrentSelectedLinkedCRF(null);
          if (listOfcurrentSelectedLinkedCRFs[i].native_crf_type != null) {
            findlinkData = getVisitLinkedCRFsData.find(
              (obj: any) => obj.OID == listOfcurrentSelectedLinkedCRFs[i].native_crf_type
            );
            if (isUpdate && !event_number.toString().includes('linkCRF')) {
              const selectedRowData: any = selectedVisit.crf_data.find(
                (item: any) => item.result.event_number == editRowData.event_number
              );
              const findEventData: any = selectedRowData.linked_crfs_data.find(
                (item: any) => item.event_number === event_number && item.native_crf_type === crf_type
              );
              const clonedObj: any = JSON.parse(JSON.stringify(findlinkData));
              clonedObj.meta.sections.map((section: any) => {
                section.rows.map((row: any) => {
                  row.fields.map((field: any) => {
                    const values = findEventData[field?.key];
                    if (field.cmp == 'checkbox' && values && Object.keys(values).length > 0) {
                      const valArr: any = [];
                      Object.keys(values).map((valkey: any) => {
                        valArr.push(valkey);
                      });
                      field.default_value = valArr;
                    } else if (field.cmp == 'select' && values && Object.keys(values).length > 0) {
                      if (field?.multiple) {
                        const multiselectVal = values?.key;
                        // const valArr: any = [];
                        // multiselectVal.map((valkey: any) => {
                        //   valArr.push(valkey?.code_list_value_code || valkey?.value);
                        // });
                        field.default_value = multiselectVal;
                      } else {
                        field.default_value = values;
                      }
                    } else {
                      field.default_value = findEventData[field?.key];
                    }
                  });
                });
              });
              const { initialValues, rules } = getDefualtValuesAndRules(clonedObj.meta);
              const formRef: any = createRef();
              formRefs.current.push(formRef);
              modifiedData.push({
                ...listOfcurrentSelectedLinkedCRFs[i],
                initialValues: {
                  ...initialValues,
                  file_data: findEventData?.file_data ? findEventData?.file_data : [],
                  event_uuid: findEventData?.event_uuid ? findEventData?.event_uuid : null
                },
                rules,
                associationTerm: clonedObj,
                formRefObj: formRef
              });
              currentLinkCRF = {
                ...listOfcurrentSelectedLinkedCRFs[i],
                initialValues: {
                  ...initialValues,
                  file_data: findEventData?.file_data ? findEventData?.file_data : [],
                  event_uuid: findEventData?.event_uuid ? findEventData?.event_uuid : null
                },
                rules,
                associationTerm: clonedObj,
                formRefObj: formRef
              };
            } else {
              let clonedMetaData = JSON.parse(JSON.stringify(findlinkData));
              const modifiedMetaData = await bindDefaultValuesToForm(clonedMetaData.meta);
              clonedMetaData = { ...clonedMetaData, meta: modifiedMetaData };
              const { initialValues, rules } = getDefualtValuesAndRules(clonedMetaData.meta);
              const formRef: any = createRef();
              formRefs.current.push(formRef);
              modifiedData.push({
                ...listOfcurrentSelectedLinkedCRFs[i],
                initialValues,
                rules,
                associationTerm: clonedMetaData,
                formRefObj: formRef,
                native_association: listOfcurrentSelectedLinkedCRFs[i].native_association,
                linked_crf_type: selectedVisit.visit_crf.OID,
                linked_association: crfAssociation.find(
                  (obj: any) => obj.trim() != listOfcurrentSelectedLinkedCRFs[i].native_association.trim()
                )
              });
              currentLinkCRF = {
                ...listOfcurrentSelectedLinkedCRFs[i],
                initialValues,
                rules,
                associationTerm: clonedMetaData,
                formRefObj: formRef,
                native_association: listOfcurrentSelectedLinkedCRFs[i].native_association,
                linked_crf_type: selectedVisit.visit_crf.OID,
                linked_association: crfAssociation.find(
                  (obj: any) => obj.trim() != listOfcurrentSelectedLinkedCRFs[i].native_association.trim()
                )
              };
            }
          } else {
            modifiedData.push(listOfcurrentSelectedLinkedCRFs[i]);
          }
        } else {
          modifiedData.push({ ...listOfcurrentSelectedLinkedCRFs[i], [event.target.name]: event.target.value });
        }
      } else {
        modifiedData.push(listOfcurrentSelectedLinkedCRFs[i]);
      }
    }
    setlistOfcurrentSelectedLinkedCRFs(modifiedData);
    if (currentLinkCRF) {
      setcurrentSelectedLinkedCRF(currentLinkCRF);
    }
  };

  // const fireOnclick = (id: any) => {
  //   const ele = document.getElementById(`native_association${id}`);
  //   if (ele) {
  //     ele.click();
  //   } else {
  //     setTimeout(() => {
  //       fireOnclick(id);
  //     }, 500);
  //   }
  // };
  const [tempField, setTempField] = useState(1);
  useEffect(() => {
    (() => {
      dispatch(showLoader());
      if (formConfig) {
        const clonedObj: any = JSON.parse(JSON.stringify(formConfig));
        if (isUpdate && selectedVisit?.crf_data.length > 0) {
          const newArray: any = [];
          const selectedRowData: any = selectedVisit.crf_data.find(
            (item: any) => item.result.event_number == editRowData.event_number
          );
          clonedObj.meta.sections.map((section: any) => {
            section.rows.map((row: any) => {
              row.fields.map((field: any) => {
                const values = selectedRowData?.result[field?.key];
                if (field.cmp == 'checkbox' && values && Object.keys(values).length > 0) {
                  const valArr: any = [];
                  Object.keys(values).map((valkey: any) => {
                    valArr.push(valkey);
                  });
                  field.default_value = valArr;
                } else if (field.cmp == 'select') {
                  if (values && Object.keys(values).length > 0) {
                    if (field?.multiple) {
                      const multiselectVal = values?.key;
                      field.default_value = multiselectVal;
                    } else {
                      field.default_value = values;
                    }
                  } else {
                    if (field?.multiple) {
                      field.default_value = [];
                    } else {
                      field.default_value = null;
                    }
                  }
                } else {
                  field.default_value = selectedRowData?.result[field?.key];
                }
              });
            });
          });
          const { initialValues, rules } = getDefualtValuesAndRules(clonedObj.meta);
          const formRef: any = createRef();
          formRefs.current.push(formRef);
          newArray.push({
            initialValues: {
              ...initialValues,
              file_data: selectedRowData?.result.file_data,
              event_uuid: selectedRowData?.result?.event_uuid
            },
            rules,
            event_number: selectedRowData?.result.event_number,
            native_association: null,
            native_crf_type: null,
            associationTerm: clonedObj,
            formRefObj: formRef,
            formId: selectedRowData?.result.event_number
          });
          if (selectedRowData && selectedRowData?.linked_crfs_data.length > 0 && getVisitLinkedCRFsData) {
            selectedRowData.linked_crfs_data.map((item: any) => {
              const findMetaObj = getVisitLinkedCRFsData.find((obj: any) => obj.OID === item.native_crf_type);
              const { initialValues, rules } = getDefualtValuesAndRules(findMetaObj.meta);

              const associationTermData = selectedRowData?.result?.bookmark_key_value
                ? typeof selectedRowData?.result.bookmark_key_value === 'object' &&
                  'key' in selectedRowData.result.bookmark_key_value
                  ? selectedRowData?.result?.bookmark_key_value?.key.map((value: any) => value.label).toString()
                  : typeof selectedRowData?.result.bookmark_key_value === 'object'
                  ? selectedRowData?.result.bookmark_cmp?.cmp == 'checkbox'
                    ? getCheckboxValue(selectedRowData?.result.bookmark_cmp, selectedRowData?.result.bookmark_key_value)
                    : selectedRowData?.result.bookmark_key_value?.label
                  : selectedRowData?.result.bookmark_cmp?.cmp == 'radio'
                  ? getRadioButtonValue(
                      selectedRowData?.result.bookmark_cmp,
                      selectedRowData?.result.bookmark_key_value
                    )
                  : selectedRowData?.result.bookmark_key_value.toString()
                : selectedRowData?.result && selectedRowData?.result.bookmark_cmp.fieldKey == 'label'
                ? selectedRowData?.result.bookmark_cmp.title
                : `${selectedRowData?.result.event_number} (${moment(selectedRowData?.result.date_of_entry).format(
                    `${userPreferedDateFormat.toUpperCase()}`
                  )})`;
              const nativeAssociationTermData = item?.bookmark_key_value
                ? typeof item?.bookmark_key_value === 'object' && 'key' in item.bookmark_key_value
                  ? item?.bookmark_key_value?.key.map((value: any) => value.label).toString()
                  : typeof item?.bookmark_key_value === 'object'
                  ? item?.bookmark_cmp?.cmp == 'checkbox'
                    ? getCheckboxValue(item?.bookmark_cmp, item?.bookmark_key_value)
                    : item?.bookmark_key_value?.label
                  : item?.bookmark_cmp?.cmp == 'radio'
                  ? getRadioButtonValue(item?.bookmark_cmp, item?.bookmark_key_value)
                  : item?.bookmark_key_value.toString()
                : item && item?.bookmark_cmp.fieldKey == 'label'
                ? item?.bookmark_cmp.title
                : `${item?.event_number} (${moment(item?.date_of_entry).format(
                    `${userPreferedDateFormat.toUpperCase()}`
                  )})`;
              const formRef: any = createRef();
              formRefs.current.push(formRef);
              newArray.push({
                formId: item.event_number,
                initialValues: { ...initialValues, file_data: item.file_data, event_uuid: item?.event_uuid },
                rules,
                event_number: item.event_number,
                native_association: item.native_association.trim(),
                native_crf_type: item.native_crf_type,
                linked_crf_type: item.linked_crf_type.trim(),
                linked_association: item.linked_association.trim(),
                associationTerm: findMetaObj,
                native_crf_custom_name: findMetaObj.custom_name,
                linked_crf_custom_name: formConfig.custom_name,
                formRefObj: formRef,
                eventData: item,
                associationTermData: associationTermData
                  ? associationTermData
                  : `${dataEntryNum} (${moment(new Date()).format(`${userPreferedDateFormat.toUpperCase()}`)})`,
                nativeAssociationTermData
              });
            });
          }
          setlistOfcurrentSelectedLinkedCRFs(null);
          setlistOfcurrentSelectedLinkedCRFs(newArray);
          setTempField(tempField + 1);
          dispatch(hideLoader());
          setDJ2FormConfig({
            ...newArray[0].associationTerm,
            ...newArray[0].associationTerm.meta
          });
          // if (newArray.length > 1) {
          //   fireOnclick(newArray[1].event_number);
          // }
        } else {
          // setUpParentFormData({ ...formConfig, meta: bindDefaultValuesToForm(clonedObj.meta) });
          const temp = { ...formConfig, meta: bindDefaultValuesToForm(clonedObj.meta) };
          const { initialValues, rules } = getDefualtValuesAndRules(temp.meta);
          const formRef: any = createRef();
          formRefs.current.push(formRef);
          setlistOfcurrentSelectedLinkedCRFs([
            {
              initialValues,
              rules,
              event_number: `linkCRF${0}`,
              native_association: null,
              native_crf_type: null,
              associationTerm: { ...formConfig, meta: bindDefaultValuesToForm(clonedObj.meta) },
              formRefObj: formRef
            }
          ]);
          dispatch(hideLoader());
        }
      }
    })();
  }, [isUpdate, formConfig, selectedVisit, getVisitLinkedCRFsData, getVisitLinkedCRFsIsSuccess]);

  useEffect(() => {
    setSourceDataReviewActive(false);
  }, [selectedVisit]);

  const [currentSelectedLinkedCRF, setcurrentSelectedLinkedCRF] = useState<any>(null);

  const formRefs: any = useRef([]);

  useEffect(() => {
    if (getPatientsDetailsData && editRowData) {
      const findVisit = getPatientsDetailsData.find((item: any) => item.study_visit.id == editRowData.visit_id);
      setselectedVisit(null);
      setselectedVisit(findVisit);
    }
  }, [getPatientsDetailsData, editRowData]);
  const updateFormConfig = (formConfigdata: any, fieldType: string) => {
    if (fieldType === 'handleVerifyBtnClick') {
      createVerification({
        data: {
          parent_id,
          subject_id,
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          created_by: user,
          record_id: editRowData?.event_uuid,
          form_oid: dj2FormConfig.OID,
          field_name: [formConfigdata.key],
          crf_data_id: editRowData?.nativeCRFId,
          visit_uuid: editRowData.visit_id
        },
        study_id: studyId,
        country: selectedCountry,
        site_id: selectedSite
      });
      setTempFormConfigdata([formConfigdata.key]);
    } else if (fieldType === 'handleClickFieldClick') {
      const tempDJ2FormConfig: any = dj2FormConfig.sections.map((section: any) => {
        return {
          rows: section.rows.map((row: any) => {
            return {
              fields: row.fields.map((field: any) => {
                if (field.source_data_reviewed === true && field.key === formConfigdata.key) {
                  return {
                    ...field,
                    showVerifyButton: true
                  };
                } else {
                  return { ...field, showVerifyButton: false };
                }
              })
            };
          })
        };
      });
      setDJ2FormConfig({ ...dj2FormConfig, sections: tempDJ2FormConfig });
    }
  };

  useEffect(() => {
    if (
      createVerificationIsSuccess &&
      listOfcurrentSelectedLinkedCRFs != null &&
      listOfcurrentSelectedLinkedCRFs.length > 0 &&
      dj2FormConfig !== null &&
      !createVerificationIsLoading &&
      createVerificationData &&
      tempFormConfigdata.length > 0
    ) {
      let verifiedCount = verifiedItems;
      let toVerifyCount = toVerifyItems;
      const tempDJ2FormConfig: any = dj2FormConfig.sections.map((section: any) => {
        return {
          rows: section.rows.map((row: any) => {
            return {
              fields: row.fields.map((field: any) => {
                if (field.visible == false) {
                  return field;
                }
                if (field.source_data_reviewed === true && tempFormConfigdata.includes(field.key)) {
                  const index = verifyAllArray.indexOf(field.key);
                  if (index > -1) {
                    verifyAllArray.splice(index, 1);
                    setVerifyAllArray(verifyAllArray);
                  }
                  verifiedCount += 1;
                  toVerifyCount -= 1;
                  return {
                    ...field,
                    isVerify: true
                  };
                } else {
                  return field;
                }
              })
            };
          })
        };
      });
      if (toVerifyCount === 0) {
        sourceDataReviewStatus({
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          parent_id,
          record_id: editRowData?.event_uuid,
          form_oid: dj2FormConfig.OID,
          visit_uuid: editRowData.visit_id,
          crf_data_id: editRowData?.nativeCRFId
        });
      }
      setVerifyAllPopup(false);
      settoVerifyItems(toVerifyCount);
      setverifiedItems(verifiedCount);
      setDJ2FormConfig({ ...dj2FormConfig, sections: tempDJ2FormConfig });
    } else if (createVerificationError && createVerificationIsError && !createVerificationIsLoading) {
      const errorData: any = createVerificationError;
      if (errorData?.status === 403) {
        dispatchApp(setMessage({ msgDetails: `${errorData?.status} : Forbbiden Access`, severity: 'error' }));
      } else if (errorData?.status === 404) {
        dispatchApp(setMessage({ msgDetails: errorData?.data?.context?.message, severity: 'error' }));
      } else if (errorData?.status === 401) {
        dispatchApp(setMessage({ msgDetails: `${errorData?.data?.detail} , Refresh the screen`, severity: 'error' }));
      } else if (errorData?.status === 500) {
        dispatchApp(setMessage({ msgDetails: errorData?.data?.context?.message, severity: 'error' }));
      } else {
        dispatchApp(setMessage({ msgDetails: `${errorData?.status} : Internal Server Error`, severity: 'error' }));
      }
    }
  }, [
    createVerificationIsSuccess,
    createVerificationIsLoading,
    createVerificationData,
    createVerificationError,
    createVerificationIsError
  ]);
  useEffect(() => {
    if (listOfcurrentSelectedLinkedCRFs != null && listOfcurrentSelectedLinkedCRFs.length && dj2FormConfig === null) {
      setDJ2FormConfig({
        ...listOfcurrentSelectedLinkedCRFs[0].associationTerm,
        ...listOfcurrentSelectedLinkedCRFs[0].associationTerm.meta
      });
    }
  }, [listOfcurrentSelectedLinkedCRFs]);

  const [verifyAllArray, setVerifyAllArray] = useState<any>([]);

  const shouldHide = (field: any, data: any) => {
    if (field['show_hide_value'] && field['show_hide']) {
      const tempOID = field['show_hide_variable_OID'];

      if (
        field['show_hide'] == 'show_if' &&
        ((typeof data[tempOID] != 'object' && field['show_hide_value'] != data[tempOID]) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID]?.value &&
            field['show_hide_value'] != data[tempOID]?.value) ||
          (typeof data[tempOID] == 'object' &&
            Array.isArray(data[tempOID]) &&
            data[tempOID] &&
            !data[tempOID].includes(field['show_hide_value'])) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID] &&
            field['show_hide_value'].includes(Object.keys(data[tempOID])) &&
            data[tempOID]?.field['show_hide_value'] == false))
      ) {
        return true;
      }
      if (
        field['show_hide'] == 'hide_if' &&
        ((typeof data[tempOID] != 'object' && field['show_hide_value'] == data[tempOID]) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID]?.value &&
            field['show_hide_value'] == data[tempOID]?.value) ||
          (typeof data[tempOID] == 'object' &&
            Array.isArray(data[tempOID]) &&
            data[tempOID].includes(field['show_hide_value'])) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID] &&
            field['show_hide_value'].includes(Object.keys(data[tempOID])) &&
            data[tempOID]?.field['show_hide_value'] == true))
      ) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    const tempArray: any = [];

    if (
      getAllVerificationIsSuccess &&
      getAllVerificationData &&
      !getAllVerificationIsLoading &&
      listOfcurrentSelectedLinkedCRFs != null &&
      listOfcurrentSelectedLinkedCRFs.length > 0 &&
      dj2FormConfig !== null
    ) {
      let verifiedCount = 0;
      let toVerifyCount = 0;
      const tempDJ2FormConfig: any = dj2FormConfig.sections.map((section: any) => {
        return {
          rows: section.rows.map((row: any) => {
            return {
              fields: row.fields.map((field: any) => {
                const formData: any = { ...listOfcurrentSelectedLinkedCRFs[0].initialValues, type: 'ce' };
                if (field.visible == false) {
                  return field;
                }
                if (shouldHide(field, formData)) {
                  return field;
                }
                if (field.source_data_reviewed === true && getAllVerificationData.includes(field.key)) {
                  verifiedCount += 1;
                  return {
                    ...field,
                    isVerify: true
                  };
                } else if (field.source_data_reviewed === true) {
                  toVerifyCount += 1;
                  tempArray.push(field.key);
                  return {
                    ...field,
                    isVerify: false
                  };
                } else {
                  return field;
                }
              })
            };
          })
        };
      });
      setVerifyAllArray(tempArray);
      setSourceDataReviewActive(true);
      settoVerifyItems(toVerifyCount);
      setverifiedItems(verifiedCount);
      setDJ2FormConfig({ ...dj2FormConfig, sections: tempDJ2FormConfig });
    } else if (
      getAllVerificationIsError &&
      getAllVerificationError &&
      !getAllVerificationIsLoading &&
      listOfcurrentSelectedLinkedCRFs != null &&
      listOfcurrentSelectedLinkedCRFs.length > 0 &&
      dj2FormConfig !== null
    ) {
      const errorData: any = getAllVerificationError;
      if (errorData.status === 404) {
        const verifiedCount = 0;
        let toVerifyCount = 0;
        const tempDJ2FormConfig: any = dj2FormConfig.sections.map((section: any) => {
          return {
            rows: section.rows.map((row: any) => {
              return {
                fields: row.fields.map((field: any) => {
                  const formData: any = { ...listOfcurrentSelectedLinkedCRFs[0].initialValues, type: 'ce' };

                  if (field.visible == false) {
                    return field;
                  }
                  if (shouldHide(field, formData)) {
                    return field;
                  }
                  if (field.source_data_reviewed === true) {
                    toVerifyCount += 1;
                    tempArray.push(field.key);
                    return {
                      ...field,
                      isVerify: false
                    };
                  } else {
                    return field;
                  }
                })
              };
            })
          };
        });
        setVerifyAllArray(tempArray);
        setSourceDataReviewActive(true);
        settoVerifyItems(toVerifyCount);
        setverifiedItems(verifiedCount);
        setDJ2FormConfig({ ...dj2FormConfig, sections: tempDJ2FormConfig });
      }
    }
    if (getAllVerificationIsError && getAllVerificationError && !getAllVerificationIsLoading) {
      const errorData: any = getAllVerificationError;
      if (errorData?.status === 403) {
        dispatchApp(setMessage({ msgDetails: `${errorData?.status} : Forbbiden Access`, severity: 'error' }));
      } else if (errorData?.status === 401) {
        dispatchApp(setMessage({ msgDetails: `${errorData?.data?.detail} , Refresh the screen`, severity: 'error' }));
      } else if (errorData?.status === 500) {
        dispatchApp(setMessage({ msgDetails: errorData?.data?.context?.message, severity: 'error' }));
      }
    }
  }, [
    getAllVerificationIsSuccess,
    getAllVerificationData,
    getAllVerificationIsError,
    getAllVerificationError,
    getAllVerificationIsLoading
  ]);
  const handelSourceDataReview = () => {
    getAllVerification({
      record_id: editRowData?.event_uuid,
      form_oid: dj2FormConfig.OID,
      parent_id,
      study_id: studyId,
      country: selectedCountry,
      site_id: selectedSite,
      crf_data_id: editRowData?.nativeCRFId,
      visit_uuid: editRowData.visit_id
    });
  };

  const [verifyAllPopup, setVerifyAllPopup] = useState<any>(false);
  const handelSourceDataVerifyAll = () => {
    createVerification({
      data: {
        parent_id,
        subject_id,
        study_id: studyId,
        country: selectedCountry,
        site_id: selectedSite,
        created_by: user,
        record_id: editRowData?.event_uuid,
        form_oid: dj2FormConfig.OID,
        field_name: verifyAllArray,
        crf_data_id: editRowData?.nativeCRFId,
        visit_uuid: editRowData.visit_id
      },
      study_id: studyId,
      country: selectedCountry,
      site_id: selectedSite
    });
    setTempFormConfigdata(verifyAllArray);
  };

  const tempEvent = { target: { name: 'associationTerm' } };

  const handleContextMenu = (event: React.MouseEvent, data: any, filedType = 'Field') => {
    if (filedType === 'Row') {
      const filtered = raisedQuerys.filter(
        (ele: any) =>
          data.find((item: any) => item.title === ele.query.report_field_label) ||
          ((ele.query.report_section_name === null || ele.query.report_section_name === 'CRF') &&
            ele.query.report_query_type === 'Section')
      );
      setShowFields({ data });
      setShowQuerys([...filtered]);
      if (data.length === 1) {
        setQueryObj({ filedType: 'Field', filedData: data[0] });
      } else {
        setQueryObj({ filedType, filedData: data });
      }
      setOpenQueryDialog(true);
    } else if (filedType === 'Section') {
      const filtered = allQueries.filter((ele: any) =>
        data.find((item: any) => item.fields.find((elem: any) => elem.key == ele.query.report_field_name))
      );
      setShowFields({ data });
      setShowQuerys([...filtered]);
      setQueryObj({ filedType, filedData: data });
      setOpenQueryDialog(true);
      setIsSectionQuery(true);
    } else {
      event.preventDefault();
      setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
      setQueryObj({ filedType, filedData: data });
    }
  };
  const [showFieldKeys, setShowFieldKeys] = useState('');
  const handleContextmenu = (key: string) => {
    if (key === 'raise_field_query') {
      setOpenRaiseQuery(true);
    }
    if (key === 'view_field_query') {
      if (queryObj?.filedData) {
        const filtered = raisedQuerys.filter((ele: any) => ele.query.report_field_label === queryObj.filedData.title);
        setShowFields({ data: key });
        setShowFieldKeys(key);
        setShowQuerys([...filtered]);
      }
      setOpenQueryDialog(true);
    }
    if (key === 'view_all_queries') {
      setShowFields({ data: key });
      setShowFieldKeys(key);
      setShowQuerys([...allQueries]);
      setOpenQueryDialog(true);
    }
    if (key === 'raise_section_query') {
      setShowFields({ data: key });
      setShowFieldKeys(key);
      setOpenRaiseQuery(true);
      setIsSectionQuery(true);
    }
    if (key === 'view_all_audit_trail') {
      setOpenAuditTrailCRF(true);
    }
    if (key === 'view_field_audit_trail') {
      setOpenFieldAuditTrailCRF(true);
    }
    setContextMenu(null);
  };
  const handleClose = () => {
    setContextMenu(null);
  };
  const {
    isLoading: getQueriesIsLoading,
    data: getQueriesData,
    error: getQueriesError,
    isError: getQueriesIsError,
    isSuccess: getQueriesIsSuccess,
    refetch: getQueries
  } = useGetQueriesQuery({
    site_id: selectedSite || '',
    study_id: studyId || '',
    country: selectedCountry || '',
    application: process.env.REACT_APP_NAME,
    application_section: 'CONDUCT',
    application_module_section: 'CRFENTRY'
  });

  useEffect(() => {
    if (getQueriesData && getQueriesIsSuccess && !getQueriesIsLoading) {
      const data: any = JSON.parse(JSON.stringify(getQueriesData));
      const allQueries = data.filter(
        (ele: any) => ele?.query?.report_category === 'CRFFLDQRY' && editRowData?.event_uuid === ele?.query?.report_id
      );
      const filtered = data.filter((ele: any) => editRowData?.event_uuid === ele?.query?.report_id);
      const sectionFiltered = data.filter(
        (ele: any) => ele?.query?.report_query_type === 'Section' && editRowData?.event_uuid === ele?.query?.report_id
      );
      setAllQueries(allQueries);
      setRaisedQuerys(filtered);
      setSectionQuerys(sectionFiltered);
      if (showFieldKeys === 'view_field_query') {
        const filteredNew = filtered.filter((ele: any) => ele.query.report_field_label === queryObj.filedData.title);
        setShowQuerys(filteredNew);
      } else if (showFieldKeys === 'view_all_queries') {
        setShowQuerys(allQueries);
      } else if (showFieldKeys === 'raise_section_query') {
        setShowQuerys(allQueries);
      } else if (showFields?.data) {
        const filteredNew = filtered.filter((ele: any) =>
          showFields?.data.find((item: any) => item.title === ele.query.report_field_label)
        );
        setShowQuerys([...filteredNew]);
      }
    }
  }, [getQueriesData, getQueriesIsSuccess, getQueriesIsLoading]);

  useEffect(() => {
    if (getQueriesIsError) {
      const error: any = getQueriesError;
      if (error?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${error?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (error?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (error.status == 404) {
        setAllQueries([]);
        setRaisedQuerys([]);
        setShowQuerys([]);
        setSectionQuerys([]);
      }
    }
  }, [getQueriesIsError]);

  useEffect(() => {
    if (getVisitLinkedCRFsIsLoading || getQueriesIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [getVisitLinkedCRFsIsLoading, getQueriesIsLoading]);
  const [auditUsersList, setAuditUsersList] = useState([]);
  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();
  useEffect(() => {
    getAssignees({
      client_name: 'ctms-ui',
      data: ['VIEW_CRF_QUERIES', 'RAISE_CRF_QUERY', 'RESPOND_QUERY_CRF']
    });
  }, []);
  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = assignees.map((item: any) => `${item.first_name} ${item.last_name}`);
      setAuditUsersList(assignList);
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (eventDataLoading || listOfcurrentSelectedLinkedCRFs === null) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [eventDataLoading, listOfcurrentSelectedLinkedCRFs]);

  return (
    <>
      {!isLoading && <Loader />}
      {isLoading ? (
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignContent={'center'}
          height={'80vh'}
          width={'calc(100% - 20px)'}
        >
          <ContentLoader />
        </Box>
      ) : (
        <>
          <Box className="formCRFHistoryModal" pb={8}>
            <Typography
              variant="h5"
              component="h5"
              mb={3}
              mt={-1}
              sx={{ fontWeight: '500', minHeight: '28px' }}
              className="crfFormFirstTitle"
            >
              {dataEntryNum ? dataEntryNum : ''}
              {editRowData && editRowData?.bookmark_key_value
                ? typeof editRowData.bookmark_key_value === 'object' && 'key' in editRowData.bookmark_key_value
                  ? `. ${editRowData?.bookmark_key_value?.key.map((value: any) => value?.label).toString()}`
                  : typeof editRowData.bookmark_key_value === 'object'
                  ? editRowData?.bookmark_cmp?.cmp == 'checkbox'
                    ? `. ${getCheckboxValue(editRowData?.bookmark_cmp, editRowData?.bookmark_key_value)}`
                    : `. ${editRowData.bookmark_key_value?.label}`
                  : editRowData?.bookmark_cmp?.cmp == 'radio'
                  ? `. ${getRadioButtonValue(editRowData?.bookmark_cmp, editRowData?.bookmark_key_value)}`
                  : `. ${editRowData.bookmark_key_value.toString()}`
                : editRowData && editRowData.bookmark_cmp.fieldKey == 'label'
                ? `. ${editRowData.bookmark_cmp.title}`
                : null}
              {bookMarkKey &&
              editRowData &&
              bookMarkKey in editRowData &&
              (editRowData[bookMarkKey] != null || bookMarkField.fieldKey == 'label') ? (
                <BookmarkIcon style={{ marginTop: '2px', height: '20px', width: '20px', marginLeft: '5px' }} />
              ) : (
                ''
              )}
            </Typography>
            {sourceDataReviewActive ? (
              <Stack direction="row" spacing={2} className="dynamic_Chiprow">
                {verifiedItems == 0 && toVerifyItems == 0 ? (
                  <Alert severity="info">No fields are configured for source data review</Alert>
                ) : verifiedItems !== 0 && toVerifyItems === 0 ? (
                  <Chip
                    icon={<CheckCircleIcon />}
                    label="Source Data Reviewed"
                    size="small"
                    className="success-light"
                  />
                ) : (
                  <>
                    <Chip
                      avatar={<Avatar>{verifiedItems}</Avatar>}
                      label="Source Data Verified"
                      size="small"
                      color="info"
                    />
                    <Chip
                      avatar={<Avatar>{toVerifyItems}</Avatar>}
                      label="Verification Needed"
                      size="small"
                      color="warning"
                    />
                  </>
                )}
              </Stack>
            ) : null}
            <Grid container spacing={2} className="formCRFHistoryModal_MainGrid">
              <Grid
                item
                xs={
                  listOfcurrentSelectedLinkedCRFs &&
                  listOfcurrentSelectedLinkedCRFs.length > 1 &&
                  currentSelectedLinkedCRF != null
                    ? 6
                    : 12
                }
              >
                {tempField &&
                listOfcurrentSelectedLinkedCRFs != null &&
                listOfcurrentSelectedLinkedCRFs.length > 0 &&
                dj2FormConfig !== null ? (
                  <div style={{ marginLeft: '-16px' }}>
                    <DJ2Form
                      formId={listOfcurrentSelectedLinkedCRFs[0].event_number}
                      key={tempField}
                      ref={listOfcurrentSelectedLinkedCRFs[0].formRefObj}
                      initialValues={{
                        ...listOfcurrentSelectedLinkedCRFs[0].initialValues,
                        formId: listOfcurrentSelectedLinkedCRFs[0].event_number
                      }}
                      rules={listOfcurrentSelectedLinkedCRFs[0].rules}
                      formConfig={{
                        ...listOfcurrentSelectedLinkedCRFs[0].associationTerm.meta,
                        sections: dj2FormConfig.sections
                      }}
                      // formConfig={dj2FormConfig}
                      onChange={onDJ2Change}
                      updateFormConfig={updateFormConfig}
                      handleContextMenu={handleContextMenu}
                      queryActive={checkPermission('view_crf_queries')}
                      queryArray={raisedQuerys}
                      isReadOnly
                      sectionActive={checkPermission('view_crf_queries') && sectionQuerys.length > 0}
                      sectionArray={sectionQuerys}
                      sourceDataReviewActive={sourceDataReviewActive}
                    />
                    {queryMenu.length ? (
                      <Menu
                        open={contextMenu !== null}
                        onClose={handleClose}
                        anchorReference="anchorPosition"
                        anchorPosition={
                          contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
                        }
                        className="contextMenu_biggerFont"
                      >
                        {queryMenu.map((ele: any) => (
                          <MenuItem key={ele.key} onClick={() => handleContextmenu(ele.key)}>
                            {ele.displayName}
                          </MenuItem>
                        ))}
                      </Menu>
                    ) : null}
                    <ViewQuery
                      setOpenQueryDialog={setOpenQueryDialog}
                      openQueryDialog={openQueryDialog}
                      openRaiseQuery={openRaiseQuery}
                      setOpenRaiseQuery={setOpenRaiseQuery}
                      queryObj={queryObj}
                      setQueryObj={setQueryObj}
                      id={editRowData?.event_uuid || ''}
                      raisedQuerys={raisedQuerys}
                      showQuerys={showQuerys}
                      getQueries={getQueries}
                      getQueriesIsLoading={getQueriesIsLoading}
                      openFieldAuditTrail={openFieldAuditTrail}
                      setOpenFieldAuditTrail={setOpenFieldAuditTrail}
                      isSectionQuery={isSectionQuery}
                      setIsSectionQuery={setIsSectionQuery}
                    />
                  </div>
                ) : null}

                <Grid item md={12}>
                  <div style={{ maxHeight: '28vh', overflowY: 'auto' }}>
                    {listOfcurrentSelectedLinkedCRFs != null &&
                      listOfcurrentSelectedLinkedCRFs.map((item: any, index: any) => {
                        if (index > 0) {
                          return (
                            <div
                              style={{ margin: '1px 0' }}
                              className="selectedCRFRow"
                              key={`listOfcurrentSelectedLinkedCRFs${index}`}
                            >
                              <Grid container spacing={2} className="add_delete_FormGrid">
                                <Grid item xs>
                                  <Grid container spacing={2} rowSpacing={0} key={item.event_number}>
                                    <Grid item md={4}>
                                      <FormControl
                                        fullWidth
                                        variant="standard"
                                        disabled={item.associationTerm != null ? true : false}
                                      >
                                        <InputLabel id={`label_Association${item.event_number}`}>
                                          Association *
                                        </InputLabel>
                                        <Select
                                          required
                                          key={item.event_number}
                                          labelId={`label_Association${item.event_number}`}
                                          id={`demo_Association${item.event_number}`}
                                          value={item.native_association ? item.native_association.trim() : null}
                                          label="Association *"
                                          name="native_association"
                                          disabled
                                          onChange={(event: any) =>
                                            handleChangeAssociation(event, item.event_number, item.native_crf_type)
                                          }
                                        >
                                          <MenuItem
                                            key={item.native_association.trim()}
                                            value={item.native_association.trim()}
                                          >
                                            {item.native_association.trim()}
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item md={4}>
                                      <FormControl
                                        fullWidth
                                        variant="standard"
                                        disabled={item.associationTerm != null ? true : false}
                                      >
                                        <InputLabel id={`label_CRFType${item.event_number}`}>CRF *</InputLabel>
                                        <Select
                                          required
                                          key={item.event_number}
                                          labelId={`label_CRFType${item.event_number}`}
                                          id={`demo_CRFType${item.event_number}`}
                                          defaultValue={item.native_crf_type}
                                          label="CRF *"
                                          name="native_crf_type"
                                          disabled
                                          onChange={(event: any) =>
                                            handleChangeAssociation(event, item.event_number, item.native_crf_type)
                                          }
                                        >
                                          <MenuItem key={item.native_crf_type} value={item.native_crf_type}>
                                            {item?.native_crf_custom_name ?? item.native_crf_type}
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item md={4}>
                                      <Autocomplete
                                        disableClearable
                                        key={item.event_number}
                                        id={`native_association${item.event_number}`}
                                        options={
                                          item?.nativeAssociationTermData ? [item.nativeAssociationTermData] : []
                                        }
                                        defaultValue={
                                          item?.nativeAssociationTermData ? [item.nativeAssociationTermData] : []
                                        }
                                        autoComplete
                                        limitTags={1}
                                        readOnly
                                        freeSolo
                                        multiple
                                        renderTags={(value, getTagProps) =>
                                          value.map((option: string, index: number) => (
                                            <Chip
                                              variant="outlined"
                                              size="small"
                                              label={option}
                                              onClick={() =>
                                                handleChangeAssociation(
                                                  tempEvent,
                                                  item.event_number,
                                                  item.native_crf_type
                                                )
                                              }
                                              {...getTagProps({ index })}
                                              key={index}
                                            />
                                          ))
                                        }
                                        renderInput={params => (
                                          <TextField
                                            // onFocus={(event: any) =>
                                            //   handleChangeAssociation(event, item.event_number, item.native_crf_type)
                                            // }
                                            name="associationTerm"
                                            label="Association Term"
                                            variant="standard"
                                            {...params}
                                          />
                                        )}
                                        className="autoCompletewSmallChip"
                                        filterSelectedOptions
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item pr={2}>
                                  <IconButton key={item.event_number} aria-label="Help" sx={{ mt: 2 }} size="small">
                                    {/* <CloseIcon /> */}
                                  </IconButton>
                                </Grid>
                              </Grid>
                            </div>
                          );
                        }
                      })}
                  </div>
                </Grid>
              </Grid>
              {currentSelectedLinkedCRF != null &&
              listOfcurrentSelectedLinkedCRFs &&
              listOfcurrentSelectedLinkedCRFs.length > 1
                ? listOfcurrentSelectedLinkedCRFs.map((linkedCrf: any, index: any) => {
                    if (linkedCrf.associationTerm != null && index > 0) {
                      const formRef: any = createRef();
                      formRefs.current.push(formRef);
                      return (
                        <Grid
                          className="crfModal-rightForm"
                          mt={-9.5}
                          pt={3}
                          key={linkedCrf.associationTerm.OID}
                          item
                          xs={6}
                          sx={
                            currentSelectedLinkedCRF?.associationTerm?.OID == linkedCrf?.associationTerm.OID &&
                            currentSelectedLinkedCRF?.event_number == linkedCrf?.event_number &&
                            currentSelectedLinkedCRF?.formRefObj === linkedCrf?.formRefObj
                              ? { display: 'block' }
                              : { display: 'none' }
                          }
                        >
                          <Typography variant="h5" component="h5" my={3} sx={{ fontWeight: '500' }}>
                            {linkedCrf?.associationTerm?.custom_name ?? linkedCrf?.associationTerm?.meta?.title}
                          </Typography>

                          <DJ2Form
                            formId={linkedCrf.event_number}
                            eventData={linkedCrf.eventData}
                            key={linkedCrf.OID}
                            ref={linkedCrf.formRefObj}
                            initialValues={{
                              ...linkedCrf.initialValues,
                              formId: linkedCrf.event_number,
                              linked_association: linkedCrf?.linked_association
                                ? linkedCrf.linked_association.trim()
                                : null,
                              native_association: linkedCrf?.native_association
                                ? linkedCrf.native_association.trim()
                                : null,
                              eventData: linkedCrf.eventData
                            }}
                            rules={linkedCrf.rules}
                            formConfig={linkedCrf.associationTerm.meta}
                            onChange={onDJ2Change}
                            updateFormConfig={updateFormConfig}
                            linked_association={
                              linkedCrf?.linked_association ? linkedCrf.linked_association.trim() : null
                            }
                            native_association={
                              linkedCrf?.native_association ? linkedCrf.native_association.trim() : null
                            }
                            isReadOnly
                            sourceDataReviewActive={sourceDataReviewActive}
                          />

                          <Box sx={{ px: 2, mt: 2 }}>
                            <Grid container spacing={2} className="add_delete_FormGrid">
                              <Grid item xs>
                                <Grid container spacing={2}>
                                  <Grid item md={4}>
                                    <FormControl fullWidth variant="standard">
                                      <InputLabel id={`label_Association${linkedCrf.event_number}`}>
                                        Association *
                                      </InputLabel>
                                      <Select
                                        required
                                        key={linkedCrf.event_number}
                                        labelId={`label_Association${linkedCrf.event_number}`}
                                        id={`demo_Association${linkedCrf.event_number}`}
                                        defaultValue={linkedCrf.linked_association.trim()}
                                        value={
                                          linkedCrf?.linked_association ? linkedCrf.linked_association.trim() : null
                                        }
                                        label="Association *"
                                        name="linked_association"
                                        disabled
                                        onChange={(event: any) =>
                                          handleChangeAssociation(
                                            event,
                                            linkedCrf.event_number,
                                            linkedCrf.native_crf_type
                                          )
                                        }
                                      >
                                        <MenuItem
                                          key={linkedCrf.linked_association.trim()}
                                          value={linkedCrf.linked_association.trim()}
                                        >
                                          {linkedCrf.linked_association.trim()}
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid item md={4}>
                                    <FormControl fullWidth variant="standard">
                                      <InputLabel id={`label_CRFType${linkedCrf.event_number}`}>CRF *</InputLabel>
                                      <Select
                                        required
                                        disabled
                                        key={linkedCrf.event_number}
                                        labelId={`label_CRFType${linkedCrf.event_number}`}
                                        id={`demo_CRFType${linkedCrf.event_number}`}
                                        value={linkedCrf.linked_crf_type}
                                        label="CRF *"
                                        name="linked_crf_type"
                                        onChange={(event: any) =>
                                          handleChangeAssociation(
                                            event,
                                            linkedCrf.event_number,
                                            linkedCrf.native_crf_type
                                          )
                                        }
                                      >
                                        <MenuItem key={linkedCrf.linked_crf_type} value={linkedCrf.linked_crf_type}>
                                          {linkedCrf?.linked_crf_custom_name ?? linkedCrf.linked_crf_type}
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid item md={4}>
                                    <Autocomplete
                                      disabled
                                      key={linkedCrf.event_number}
                                      multiple
                                      id={`tags-standard${linkedCrf.event_number}`}
                                      options={linkedCrf?.associationTermData ? [linkedCrf.associationTermData] : []}
                                      defaultValue={
                                        linkedCrf?.associationTermData ? [linkedCrf.associationTermData] : []
                                      }
                                      limitTags={1}
                                      freeSolo
                                      renderTags={(value: readonly string[], getTagProps: any) =>
                                        value.map((option: string, index: number) => (
                                          <Chip
                                            variant="outlined"
                                            size="small"
                                            label={option}
                                            {...getTagProps({ index })}
                                            key={index}
                                          />
                                        ))
                                      }
                                      renderInput={params => (
                                        <TextField
                                          label="Association Term"
                                          {...params}
                                          name="associationTerm"
                                          variant="standard"
                                        />
                                      )}
                                      className="autoCompletewSmallChip"
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item>
                                <IconButton
                                  disabled
                                  key={linkedCrf.event_number}
                                  aria-label="Help"
                                  sx={{ mt: 2 }}
                                  size="small"
                                >
                                  <CloseIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                      );
                    }
                  })
                : null}
            </Grid>
            <Grid container className="ModalFooterRow" mb={-8}>
              <Grid item xs={9}>
                {checkPermission('review_crf_source_data') ? (
                  <Button onClick={handelSourceDataReview} variant="outlined">
                    Source data review
                  </Button>
                ) : null}
                {checkPermission('review_crf_source_data') && sourceDataReviewActive && toVerifyItems > 0 ? (
                  <Button onClick={() => setVerifyAllPopup(true)} variant="outlined">
                    Source data verify all
                  </Button>
                ) : null}
              </Grid>
              <Grid item xs={3} className="rightAlignBtns">
                <Button onClick={handleCloseModel} variant="text">
                  Close
                </Button>
              </Grid>
            </Grid>
            <Dialog open={verifyAllPopup}>
              {/* <DialogTitle>Verify All</DialogTitle> */}
              <DialogContent>
                <DialogContentText>Are you sure to verify all the fields at once?</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handelSourceDataVerifyAll}>Yes</Button>
                <Button onClick={() => setVerifyAllPopup(false)}>No</Button>
              </DialogActions>
            </Dialog>
          </Box>
          <PopupComponent
            open={openAuditTrailCRF || openFieldAuditTrailCRF}
            child
            // sx={{ '& .MuiDialog-paper': { maxWidth: 'unset !important' } }}
            maxWidth="md"
          >
            <AuditTrailContent
              handleCloseAudit={() => {
                setOpenAuditTrailCRF(false);
                setOpenFieldAuditTrailCRF(false);
              }}
              auditUsersList={auditUsersList}
              audit_module_section={`CRFENTRY`}
              id={editRowData?.event_uuid}
              AdvancedFilterArray={staticData.AdvancedQueryFilter}
              isCRFForm={openAuditTrailCRF}
              formDetails={listOfcurrentSelectedLinkedCRFs?.[0]?.associationTerm?.meta}
              isFieldForm={openFieldAuditTrailCRF}
              fieldDetails={queryObj}
            />
          </PopupComponent>
        </>
      )}
    </>
  );
};

export default CRFHistoryModal;
